export function initGrowtypeSidebarEvent(params) {
    return new CustomEvent("growtypeInitSidebar", {
        detail: params
    });
}
